module.exports = __webpack_public_path__ + "static/mailbox2-9e5d72a83b0e985407f7c227999415ff.jpg";